import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Image,
  Text,
  Input,
  Checkbox,
  Popover,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  HStack,
  Spacer,
  Flex,
  PopoverTrigger,
  Tooltip,
  PopoverFooter,
  Button,
  Center,
  useToast,
  Portal
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import { FaCalendar, FaPlus } from 'react-icons/fa'
import { GiCardExchange } from 'react-icons/gi'

import useReabTimeline from '@hook/parametrization/use-reab-timeline'
import useFilters from '@hook/shared/use-filters'

import {
  IParamsDates,
  IUpdateParamsDate
} from '@base/@types/providers/Parametrization/MinimumBillingProvider'

interface SpecialScheduleProps {
  activeTimeline?: number
  setActiveTimeLine?: (timeline: number) => void
  initialSchedule?: { [key: string]: string[] }
  onScheduleChange?: (newSchedule: { [key: string]: string[] }) => void
  paramsDate?: IParamsDates
  updateParamsDate?: (params: IUpdateParamsDate) => void
  setorId?: number
}

const daysOfWeek = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta']

const SpecialScheduleV2: FC<SpecialScheduleProps> = ({
  activeTimeline,
  setActiveTimeLine,
  initialSchedule = {
    Segunda: ['1001', '1002', '1003'],
    Terça: ['1001', '1002'],
    Quarta: ['1001'],
    Quinta: ['1001', '1002'],
    Sexta: ['1001', '1002', '1003']
  },
  onScheduleChange,
  paramsDate,
  updateParamsDate,
  setorId = 1
}) => {
  const [indexError, setIndexError] = useState('')

  const [schedule, setSchedule] =
    useState<{ [key: string]: any[] }>(initialSchedule)
  const { centers } = useFilters()
  const toast = useToast()
  const { setIsChange } = useReabTimeline()

  const addNewRow = (day: string) => {
    const lastid = schedule[day][schedule[day].length - 1]
    if (lastid !== '') {
      const updatedSchedule = {
        ...schedule,
        [day]: [...schedule[day], '']
      }
      setSchedule(updatedSchedule)
    }
  }
  function getDayNumber(day: string): number {
    const daysOfWeek: { [key: string]: number } = {
      segunda: 1,
      terça: 2,
      quarta: 3,
      quinta: 4,
      sexta: 5,
      sábado: 6,
      domingo: 0
    }

    const normalizedDay = day.toLowerCase() // Normaliza para evitar problemas com maiúsculas/minúsculas
    return daysOfWeek[normalizedDay] ?? -1
  }
  const handleInputChange = (day: string, index: number, value: string) => {
    const updatedSchedule = {
      ...schedule,
      [day]: schedule[day].map((item, idx) => (idx === index ? value : item))
    }
    setSchedule(updatedSchedule)
    // onScheduleChange?.(updatedSchedule)
  }

  const handleRemoveItem = (day: string, index: number) => {
    const updatedSchedule = {
      ...schedule,
      [day]: schedule[day].filter((_, idx) => idx !== index) // Remover o item pelo índice
    }

    setSchedule(updatedSchedule)
    onScheduleChange?.(updatedSchedule)
  }

  const [, setFocusedInput] = useState<{
    day: string
    index: number
  } | null>(null)

  const handleFocus = (day: string, index: number) =>
    setFocusedInput({ day, index })
  const handleBlur = (day: string, index: number) => {
    // Filtra os itens do array, ignorando os que não são objetos
    const lojaId = schedule[day][index]

    const filteredData = schedule[day].filter(
      item => typeof item === 'object' && item !== null
    )

    // Procura pelo item com o lojaId desejado
    const result = filteredData.find(item => item.lojaId === lojaId)
    if (lojaId === '') {
      setIndexError('')
      toast({
        title: 'Atencao.',
        description:
          'Você digitou um valor incorreto ou não digitou nenhum valor.',
        status: 'warning',
        duration: 2000,
        isClosable: true
      })
      handleRemoveItem(day, index)
      return
    }
    if (centers.findIndex((x: any) => x.value === Number(lojaId)) === -1) {
      setIndexError(day + index)

      toast({
        title: 'Atencao.',
        description: 'Loja Id nao existe',
        status: 'warning',
        duration: 2000,
        isClosable: true
      })
      return
    }
    if (result !== undefined) {
      setIndexError(day + index)

      toast({
        title: 'Atencao.',
        description: 'Loja Id já está cadastrada no cronograma',
        status: 'warning',
        duration: 2000,
        isClosable: true
      })
      return
    }
    setIndexError('')
    setIsChange(true)
    const updatedSchedule = {
      ...schedule,
      [day]: schedule[day].map((item, idx) =>
        idx === index
          ? {
              previsaoEntrega: [],
              id: '',
              centroDistribuicaoId: '',
              tipoCronograma: 2,
              setorId: setorId,
              lojaId: item,
              diaDaSemana: getDayNumber(day),
              ativo: activeTimeline === 1,
              dataInicio: paramsDate.dateInit,
              dataFim: paramsDate.dateEnd
            }
          : item
      )
    }
    setSchedule(updatedSchedule)
    onScheduleChange?.(updatedSchedule)
    setFocusedInput(null)
  }
  const [isFlipped, setIsFlipped] = useState(false)

  function convertToBRFormat(dateISO: string): string {
    const [year, month, day] = dateISO.split('-')
    return `${day}/${month}/${year}`
  }

  const getNameLoja = (lojaId: any) => {
    const lojdIdCenter = centers.find(x => x.value === Number(lojaId))
    if (lojdIdCenter === null) {
      return lojaId
    } else {
      return lojdIdCenter.label
    }
  }
  return (
    <Box justifyContent="center" p={4}>
      <Box border="1px solid #ccc" borderRadius="md" p={4} bg="gray.10">
        <HStack spacing={5} direction="row" mb={4}>
          <Checkbox
            border="black"
            borderWidth="2px"
            isChecked={activeTimeline === 1}
            borderRadius="md"
            onChange={() => {
              setActiveTimeLine(1)
            }}
            _checked={{ borderColor: 'black' }}
          ></Checkbox>
          <Text color="black">Ativo</Text>
          <Spacer />
          <Box fontSize="lg" fontWeight="bold" mb={4} textAlign="center">
            Cronograma Especial
          </Box>

          <Spacer />
          <Text color="black">
            {convertToBRFormat(paramsDate.dateInit.toString())} a{' '}
            {convertToBRFormat(paramsDate.dateEnd.toString())}
          </Text>
          <Tooltip label="Clique aqui para Alterar !" placement="top">
            <Popover>
              <PopoverTrigger>
                <IconButton
                  className="icon-button"
                  aria-label={'Add row to '}
                  icon={<FaCalendar color="white" />}
                  size="xs"
                  variant="solid"
                  bg="green"
                  isRound
                />
              </PopoverTrigger>
              <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverBody bg="white">
                  Selecione o peridodo desejado
                  <Flex
                    flex={1}
                    mr={{ base: 0, md: 4 }}
                    mb={{ base: 4, md: 0 }}
                    mt={4}
                  >
                    <Text fontWeight={700} mt={2}>
                      Início:{'\u00a0'}
                    </Text>
                    <Input
                      type="date"
                      onChange={value =>
                        updateParamsDate({
                          name: 'dateInit',
                          value: value.target.value
                        })
                      }
                      bg="white"
                      value={paramsDate.dateInit}
                    />
                  </Flex>
                  <Flex
                    flex={1}
                    mr={{ base: 0, md: 4 }}
                    mb={{ base: 4, md: 0 }}
                  >
                    <Text fontWeight={700} mt={2}>
                      Fim:{'\u00a0'}
                    </Text>
                    <Input
                      type="date"
                      bg="white"
                      onChange={value =>
                        updateParamsDate({
                          name: 'dateEnd',
                          value: value.target.value
                        })
                      }
                      value={paramsDate.dateEnd}
                    />
                  </Flex>
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </Tooltip>
          <IconButton
            className="icon-button"
            aria-label={'Add row to '}
            icon={<GiCardExchange color="white" />}
            size="xs"
            variant="solid"
            bg="green"
            onClick={() => setIsFlipped(!isFlipped)}
            isRound
          />
        </HStack>

        <Box display="flex" alignItems="flex-start">
          {daysOfWeek.map(day => (
            <Table
              key={day}
              variant="simple"
              size="sm"
              borderLeft={day !== 'Segunda' ? '1px solid #ccc' : 'none'}
            >
              <Thead>
                <Tr>
                  <Th
                    bg="green.700"
                    textAlign="center"
                    fontSize="md"
                    fontWeight="bold"
                    colSpan={2}
                    color="white"
                  >
                    {day.toUpperCase()}
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {(schedule[day] || []).map((value, index) => (
                  <Tr key={index}>
                    <Td
                      textAlign="center"
                      p={2}
                      border="1px solid #ddd"
                      _hover={{
                        '.input-old': { borderColor: 'red' },
                        '.trash-button': { opacity: 1 }
                      }}
                    >
                      <Box className={`flipper ${isFlipped ? 'active' : ''}`}>
                        {/* Frente do componente */}
                        <Box className="front">
                          <Tooltip
                            label={
                              <Box whiteSpace="pre-line">
                                {value?.previsaoEntrega
                                  ?.map(
                                    (item: any) =>
                                      `Entrega ${item.centroDistribuicaoId}: ${item.previsaoEntrega}`
                                  )
                                  .join('\n')}
                              </Box>
                            }
                            placement="top"
                          >
                            <Box>
                              <Popover>
                                {
                                  // O PopoverTrigger será renderizado somente quando o Input estiver desabilitado
                                  value?.id !== undefined ? (
                                    <PopoverTrigger>
                                      <Box
                                        className="input-old"
                                        value={value.lojaId}
                                        size="sm"
                                        textAlign="center"
                                        border="1px solid"
                                        width="100px"
                                        borderColor={'#ddd'}
                                        padding="0 8px" // Adiciona um pouco de padding para ficarem alinhados
                                        lineHeight="32px" // Ajusta a altura da linha para parecer com o input
                                        isDisabled // Torna o campo não editável, mas visualmente igual ao Input
                                      >
                                        {getNameLoja(value.lojaId)}
                                      </Box>
                                    </PopoverTrigger>
                                  ) : (
                                    <Input
                                      className="input-old"
                                      value={value.lojaId}
                                      onChange={e =>
                                        handleInputChange(
                                          day,
                                          index,
                                          e.target.value
                                        )
                                      }
                                      size="sm"
                                      bg={
                                        indexError === day + index.toString()
                                          ? 'orange.200'
                                          : 'white'
                                      }
                                      isDisabled={value?.id !== undefined} // Input desabilitado quando value.id não for undefined
                                      textAlign="center"
                                      border="1px solid"
                                      borderColor={'#ddd'}
                                      onFocus={() => handleFocus(day, index)}
                                      onBlur={() => handleBlur(day, index)}
                                    />
                                  )
                                }
                                <Portal>
                                  <PopoverContent>
                                    <PopoverArrow />
                                    <PopoverCloseButton />
                                    <PopoverBody bg="white">
                                      <Center>
                                        <Image
                                          width="50%"
                                          src="https://imgvisuals.com/cdn/shop/products/animated-failure-sign-color-ui-icon-786212.gif?v=1698144442"
                                        />
                                      </Center>
                                      <Flex
                                        flex={1}
                                        mr={{ base: 0, md: 4 }}
                                        mb={{ base: 4, md: 0 }}
                                        mt={4}
                                      >
                                        <Text fontWeight={700} mt={2}>
                                          Deseja remover a Loja `
                                          {value?.lojaId || 'N/A'}` do dia `
                                          {day || 'N/A'}`? Essa ação é
                                          irreversível.
                                        </Text>
                                      </Flex>
                                    </PopoverBody>
                                    <PopoverFooter
                                      bg="white"
                                      border="0"
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      pb={4}
                                    >
                                      <Button
                                        background="red.300"
                                        color="white"
                                        onClick={() =>
                                          handleRemoveItem(day, index)
                                        }
                                      >
                                        Remover!
                                      </Button>
                                    </PopoverFooter>
                                  </PopoverContent>
                                </Portal>
                              </Popover>
                            </Box>
                          </Tooltip>
                          <Flex></Flex>
                        </Box>

                        {/* Verso do componente */}
                        <Box className="back">
                          {value?.previsaoEntrega !== undefined && isFlipped && (
                            <>
                              <Box whiteSpace="pre-line">
                                {value?.previsaoEntrega
                                  ?.map(
                                    (item: any) =>
                                      `Entrega ${item.centroDistribuicaoId}: ${item.previsaoEntrega}`
                                  )
                                  .join('\n')}
                              </Box>
                            </>
                          )}
                        </Box>
                      </Box>
                    </Td>
                  </Tr>
                ))}
                <Tr>
                  <Td
                    textAlign="center"
                    colSpan={2}
                    p={1}
                    border="1px solid #ddd"
                    _hover={{ '.icon-button': { opacity: 1 } }}
                  >
                    <IconButton
                      className="icon-button"
                      aria-label={`Add row to ${day}`}
                      icon={<FaPlus />}
                      size="xs"
                      variant="solid"
                      colorScheme="red"
                      onClick={() => addNewRow(day)}
                      isRound
                      opacity={0}
                      transition="opacity 0.2s"
                    />
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default SpecialScheduleV2
